<template>
  <div>
    <v-slide-x-reverse-transition>
      <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
    </v-slide-x-reverse-transition>
    <v-card elevation="6">
      <div class="mt-6 pa-4 grid_flex justify-space-between">
        <div class="pa-4">
          <span style="font-size: 24px">รายการสินค้า</span>
        </div>
        <!--          <div class="text-right">-->
        <!--            <router-link to="/stock/storage/returncn">-->
        <!--              <v-btn x-large class="grad-success-bg white&#45;&#45;text btn_size btn_mobile">-->
        <!--                ใบส่งคืนสินค้า-->
        <!--              </v-btn>-->
        <!--            </router-link>-->
        <!--          </div>-->
      </div>
      <div class="grid_tab mt-n6">
        <v-divider />
        <v-tabs grow show-arrows color="#86bc3a">
          <v-tab @click="page(1)" style="font-size:16px;">สินค้าไม่ได้สั่ง</v-tab>
          <v-tab @click="page(2)" style="font-size:16px;">สินค้าชำรุด</v-tab>
          <v-tab @click="page(3)" style="font-size:16px;">สินค้าเคลมใกล้หมดอายุ</v-tab>
        </v-tabs>
        <v-divider />
      </div>

      <!-- เลือกเดือน เลือกปี -->
      <div class="pa-4">
        <v-row>
          <v-col cols="12" sm="4" md="4">
            <v-select v-model="selectedMonth" :items="months" item-text="name" item-value="value"
              label="กรุณาเลือกเดือน" color="#86bc3a" outlined dense clearable></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-select v-model="selectedYear" :items="years" label="กรุณาเลือกปี" color="#86bc3a" outlined dense
              clearable></v-select>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-btn @click="filterData" class="grad-success-bg white--text" height="40" block>
              <v-icon left>mdi-magnify</v-icon>
              ค้นหา
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
      </div>
      <div v-else class="pa-2">
        <v-card-title>
          <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
            hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="expireHeaders" :items="expireList" :footer-props="footer_Props" :search="search"
          mobile-breakpoint="0">
          <template slot="item" slot-scope="dataDetail">
            <tr>
              <td>{{ dataDetail.item.product_code }}</td>
              <td>{{ dataDetail.item.product_name }}</td>
              <!--                <td><v-switch color="#86bc3a" @change="changeStatus(dataDetail.item.product_id, dataDetail.item.status)" v-model="dataDetail.item.status"></v-switch></td>-->
              <td style="color: red">{{ dataDetail.item.sum }}</td>
              <td class="pa-3"><v-btn @click="getDetails(dataDetail.item.product_id)"
                  class="pa-6 grad-success-bg white--text" title="รายละเอียด"><v-icon>mdi-magnify</v-icon>
                  ดูรายละเอียด</v-btn></td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Return_stock",
  data() {
    return {
      loading_page: false,
      search: '',
      alert_success: false,
      title: 1,
      selectedMonth: null,
      selectedYear: null,
      months: [
        { name: 'มกราคม', value: 1 },
        { name: 'กุมภาพันธ์', value: 2 },
        { name: 'มีนาคม', value: 3 },
        { name: 'เมษายน', value: 4 },
        { name: 'พฤษภาคม', value: 5 },
        { name: 'มิถุนายน', value: 6 },
        { name: 'กรกฎาคม', value: 7 },
        { name: 'สิงหาคม', value: 8 },
        { name: 'กันยายน', value: 9 },
        { name: 'ตุลาคม', value: 10 },
        { name: 'พฤศจิกายน', value: 11 },
        { name: 'ธันวาคม', value: 12 }
      ],
      years: [],
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      expireHeaders: [
        {
          text: 'รหัส',
          value: 'product_code',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        // {
        //   text: 'สถานะขาย',
        //   value: 'status',
        //   sortable: false,
        //   fixed: true,
        //   width: '120px',
        // },
        {
          text: 'จำนวนรอคืน',
          value: 'damaged',
          fixed: true,
          width: '120px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '120px',
        },
      ],
      expireList: [],
    }
  },
  methods: {
    generateYears() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 5; // ย้อนหลัง 5 ปี
      const endYear = currentYear + 1; // ล่วงหน้า 1 ปี

      for (let year = endYear; year >= startYear; year--) {
        this.years.push(year + 543); // แปลงเป็น พ.ศ.
      }
    },
    page(type) {
      this.title = type
      this.selectedMonth = null
      this.selectedYear = null
      this.expireHeaders = [
        {
          text: 'รหัส',
          value: 'product_code',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '200px',
        },
        // {
        //   text: 'สถานะขาย',
        //   value: 'status',
        //   sortable: false,
        //   fixed: true,
        //   width: '120px',
        // },
        {
          text: 'จำนวนรอคืน',
          value: 'damaged',
          fixed: true,
          width: '120px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '120px',
        },
      ]
      this.get_data()
    },
    filterData() {
      // this.get_data()
      if (!this.selectedMonth || !this.selectedYear) {
        Swal.fire({
          title: 'กรุณาเลือกข้อมูล',
          text: 'กรุณาเลือกเดือนและปีก่อนค้นหา',
          icon: 'warning',
          confirmButtonText: 'ตกลง'
        });
        return;
      }

      const route = this.$router.resolve({
        name: 'ReturnDetailsNew',
        params: {
          type: this.title
        },
        query: {
          month: this.selectedMonth,
          year: this.selectedYear - 543
        }
      });

      window.open(route.href, '_blank');
    },
    get_data() {
      this.loading_page = true
      console.log(this.title);
      HTTP.post('/inventory/returns/getreturnstorage', {
        type_return: this.title,
        month: this.selectedMonth,
        year: this.selectedYear ? this.selectedYear - 543 : null // แปลง พ.ศ. เป็น ค.ศ.
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.expireList = res.data.object
        }
      })
    },
    changeStatus(product_id, status) {
      if (status == true) {
        this.status_id = 1;
      }
      else if (status == false) {
        this.status_id = 0;
      }
      this.disabled_status = true
      HTTP.post('/products/product/changestatus', {
        status: this.status_id,
        product_id: product_id
      }).then((res) => {
        if (res.data.success === true) {
          this.disabled_status = false
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 3000);
        }
        else {
          Swal.fire({
            title: 'ไม่สามารถดำเนินการได้ !',
            text: res.data.message,
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.disabled_status = false
            this.getProduct()
          })
        }
      })
    },
    getDetails(id) {
      this.$router.push('/stock/storage/returndetails/' + id + '/' + this.title)
    }
  },
  mounted() {
    this.generateYears()
    this.page(1)
  }
}
</script>

<style scoped>
.btn_size {
  font-size: 18px;
}

.grid_flex {
  display: flex;
}

@media only screen and (max-width: 600px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
  }

  .btn_mobile {
    width: 100% !important;
  }
}
</style>
